<script>
import LoginFormFooterTermAndCondition from './LoginFormFooterTermAndCondition.vue'

import BaseButton from '@/components/lavender/Button/BaseButton.vue'

export default {
  name: 'LoginFormAction',
  components: {
    LoginFormFooterTermAndCondition,
    BaseButton,
  },
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    submittingGoogleSso: {
      type: Boolean,
      default: false,
    },
    redirectingToOnboarding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabledLoginButton() {
      return (
        this.disabled ||
        this.submitting ||
        this.submittingGoogleSso ||
        this.redirectingToOnboarding
      )
    },
    disabledGoogleLoginButton() {
      return (
        this.submittingGoogleSso ||
        this.submitting ||
        this.redirectingToOnboarding
      )
    },
    disabledSignupButton() {
      return (
        this.redirectingToOnboarding ||
        this.disabled ||
        this.submitting ||
        this.submittingGoogleSso
      )
    },
  },
}
</script>

<template>
  <div class="tamara-login-form__action">
    <LoginFormFooterTermAndCondition />
    <BaseButton
      type="primary"
      class="mt-4"
      :loading="submitting"
      :disabled="disabledLoginButton"
      @click="$emit('click:login')"
    >
      {{ $t('login_login_button') }}
    </BaseButton>
    <BaseButton
      type="outline"
      class="mt-4"
      :disabled="disabledLoginButton"
      :loading="redirectingToOnboarding"
      @click="$emit('click:signup')"
    >
      {{ $t('login_sign_up_button_label') }}
    </BaseButton>
    <el-divider>{{ $t('login_action_divider_label') }}</el-divider>
    <BaseButton
      type="default"
      class="tamara-login-form__action__google-login-button"
      :loading="submittingGoogleSso"
      :disabled="disabledGoogleLoginButton"
      @click="$emit('click:google-login')"
    >
      <div
        class="flex items-center justify-center w-full gap-2 tamara-login-form__action__google-login-button-label"
      >
        <svg-icon icon-class="google-login" />
        <span>{{ $t('google_login_button') }}</span>
      </div>
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-login-form__action {
  display: flex;
  flex-direction: column;

  &__google-login-button {
    margin-inline: 0;
    color: var(--tamara-color-functional-grey-dark-3);

    &:active,
    &:focus {
      color: var(--tamara-color-text-light-primary);
    }
  }

  &__google-login-button-label {
    @extend .tamara-title-medium;
  }
}
</style>
